import { render, staticRenderFns } from "./ReadDisclaimer.vue?vue&type=template&id=6afb0189&scoped=true"
import script from "./ReadDisclaimer.vue?vue&type=script&lang=js"
export * from "./ReadDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./ReadDisclaimer.vue?vue&type=style&index=0&id=6afb0189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb0189",
  null
  
)

export default component.exports